export const DATE_ONLY_PATTERN = "^(\\d{4}-\\d{2}-\\d{2})$";
